import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { ModalHeader } from '@/components/Modal'

import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function Header() {
  const {
    close,
    data: { orderStepIds },
  } = useController()

  const texts = useTexts()

  return (
    <ModalHeader
      title={texts.title(orderStepIds.length, 'partial')}
      subtitle={texts.subtitle}
      actions={[
        <ActionBarItem
          icon={<Close />}
          testId="close-button"
          key="close"
          onClick={close}
          label=""
        />,
      ]}
    />
  )
}
